import { render, staticRenderFns } from "./GlobalSetting.vue?vue&type=template&id=e5bcd7c8&scoped=true&"
import script from "./GlobalSetting.vue?vue&type=script&lang=js&"
export * from "./GlobalSetting.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSetting.vue?vue&type=style&index=0&id=e5bcd7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bcd7c8",
  null
  
)

export default component.exports